const nl = {
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Inloggen',
  'nav.signOut': 'Uitloggen',
  'nav.signingIn': 'Bezig met inloggen…',
  'nav.loading': 'Laden…',
  'nav.backToDashboard': 'Terug naar dashboard',
  'nav.back': 'Terug',
  'nav.language': 'Taal',

  'credits.label': 'Credits: {count}',
  'credits.loading': 'Credits: —',
  'credits.buyMore': 'Credits kopen',
  'credits.tooltipBuy': 'Klik om meer credits te kopen',
  'credits.tooltipLoading': 'Je creditsaldo wordt geladen',

  'auth.title': 'Log in om verder te gaan',
  'auth.subtitle': 'Log in met Google om je gratis credits te krijgen en je gebruik te volgen',
  'auth.google': 'Doorgaan met Google',
  'auth.signOutFailed': 'Uitloggen is niet gelukt. Probeer het opnieuw.',
  'auth.signInFailed': 'Inloggen is niet gelukt. Probeer het opnieuw.',

  'landing.headline': 'Maak de foto die je niet hebt genomen.',
  'landing.sub': 'Log in om te beginnen. De eerste drie credits zijn van ons.',
  'landing.note': 'Eén credit per afbeelding, pas afgeschreven als de afbeelding er is.',

  'dash.eyebrow': 'Gereedschap',
  'dash.headline': 'Maak de foto die je niet hebt genomen.',
  'dash.sub': 'Kies een tool. Elke tool kost één credit, en alleen als het lukt.',

  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Kaart → uitzicht',
  'tool.arrow.desc': 'Zet een pijl ergens op de kaart en zie hoe het uitzicht daarvandaan is.',
  'tool.person.name': 'Personen verwijderen',
  'tool.person.transform': 'Drukte → leeg',
  'tool.person.desc': 'Haal de onbekenden uit je foto en houd de plek waar je was.',
  'tool.clothing.name': 'Virtueel passen',
  'tool.clothing.transform': 'Kleding → jij',
  'tool.clothing.desc': 'Pas een kledingstuk voordat je besluit het te kopen.',

  'upload.title': 'Upload je afbeelding',
  'upload.hint': 'Klik om een afbeelding te kiezen of sleep hem hierheen',
  'upload.formats': 'Formaten: JPG, PNG, GIF • Maximaal 10 MB',
  'upload.person': 'Upload de foto van de persoon',
  'upload.clothing': 'Upload de foto van het kledingstuk',
  'upload.selectImage': 'Klik om een afbeelding te kiezen',
  'upload.formatsShort': 'JPG, PNG — max. 10 MB',
  'upload.tooLarge': 'Die afbeelding is groter dan 10 MB. Kies een kleinere.',
  'upload.notImage': 'Dat bestand is geen afbeelding. Kies een JPG of PNG.',

  'action.generate': 'Genereren',
  'action.generating': 'Bezig met genereren…',
  'action.download': 'Downloaden',
  'action.share': 'Delen',
  'action.delete': 'Verwijderen',
  'action.cancel': 'Annuleren',
  'action.tryAgain': 'Opnieuw proberen',
  'action.uploadCustom': 'Eigen foto uploaden',
  'action.browseLibrary': 'Bibliotheek bekijken',

  'history.show': 'Recente afbeeldingen tonen ({count})',
  'history.hide': 'Recente afbeeldingen verbergen',
  'history.empty': 'Nog niets. Je gegenereerde afbeeldingen verschijnen hier.',

  'gen.working': 'Je afbeelding wordt gemaakt…',
  'gen.takesTime': 'Dit duurt meestal minder dan een minuut.',
  'gen.noCredits': 'Je credits zijn op. Koop er meer om verder te gaan.',
  'gen.failed': 'Dat is niet gelukt. Je credit is niet afgeschreven.',
  'gen.blocked': 'Het veiligheidsfilter heeft die foto geweigerd. Probeer een andere — je credit is niet afgeschreven.',

  'pay.title': 'Credits kopen',
  'pay.subtitle': 'Credits verlopen niet.',
  'pay.creditsLabel': '{count} credits',
  'pay.saved': '{amount} bespaard',
  'pay.pay': '{amount} betalen',
  'pay.processing': 'Bezig met verwerken…',
  'pay.success': 'Betaling voltooid. Je credits zijn toegevoegd.',
  'pay.failed': 'Betaling mislukt. Er is niets afgeschreven.',
  'pay.completeTitle': 'Betaling voltooid',
  'pay.completeBody': 'Je credits zijn aan je account toegevoegd.',

  'error.title': 'Er is iets misgegaan',
  'error.body': 'De pagina liep tegen een onverwachte fout aan. Opnieuw laden helpt meestal.',
  'error.reload': 'Pagina opnieuw laden',
  'notFound.title': 'Pagina niet gevonden',
  'notFound.body': 'Dat adres hoort bij niets in de studio.',
  'notFound.home': 'Naar het dashboard',

  'footer.privacy': 'Privacybeleid',
};

export default nl;
